import {importLibrary, setOptions} from '@googlemaps/js-api-loader';
import {GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_STORE_MAP_ID} from '../../config';

const libraries = ['maps', 'marker', 'places', 'core'];

setOptions({
    key: GOOGLE_MAPS_API_KEY,
    language: 'fr-FR',
    region: 'fr',
    libraries,
    mapIds: [GOOGLE_MAPS_STORE_MAP_ID],
});
/**
 * @type {Promise<[google.maps.MapsLibrary, google.maps.MarkerLibrary, google.maps.PlacesLibrary, google.maps.CoreLibrary]>}
 */
const googleMaps = Promise.all(libraries.map(library => importLibrary(library)));

export default () => googleMaps;
